module.exports = __webpack_public_path__ + "h5/img/order.3897cdde.png";